(() => {
  const attach = () => {
    const section = document.querySelector('[data-native-entry-section]');
    const button = section?.querySelector('[data-native-home-button]');
    if (!button) return;
    const row = document.querySelector('.zn-content[data-id="18310"] #znid-314750969171 .zn-row');
    if (!row || row.hasAttribute('data-native-entry-group')) return;
    const children = [...row.children];
    const paths = ['/collections/recommended', '/pages/home', '/blogs/paterns-in-japanese', '/pages/brand'];
    if (children.length !== paths.length) return;
    if (!children.every((child, i) => {
      const link = child.querySelector('a[href]');
      if (!link || !child.querySelector('img')) return false;
      try { return new URL(link.href, location.href).pathname === paths[i]; }
      catch { return false; }
    })) return;
    row.append(button);
    row.setAttribute('data-native-entry-group', '');
    section.hidden = true;
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach, { once: true });
  else attach();
  document.addEventListener('shopify:section:load', attach);
})();
